import { EstadoPagoGTModalContent } from './EstadoPagoGTModalContent';
import { EstadoPagoGTModalAgregar } from './EstadoPagoGTModalAgregar';

export const getEstadoPagoModal = (tipo, props = {}) => {
  switch (tipo) {
    // case 'BH':
    //   return <EstadoPagoBHModalContent {...props} />;
    // case 'GH':
    //   return <EstadoPagoGHModalContent {...props} />;
    case 'GT_ADD':
      return <EstadoPagoGTModalAgregar {...props} />;
    case 'GT':
      return <EstadoPagoGTModalContent {...props} />;
    default:
      return <EstadoPagoGTModalContent {...props} />;
  }
};